<template>
  <UserOrderList
    orderType="b"
  />
</template>

<script>
import UserOrderList from '@/components/Order/order-list.vue';

export default {
  components: {
    UserOrderList,
  },
}
</script>